// Foundations
import { Injectable, Injector } from '@angular/core';

// rxjs
import { filter, map, ReplaySubject, take } from 'rxjs';

// Services
import { GetAccountIdGQL } from '@app/services/graphql.service';
import { getLastAuthUser } from '@app/services/cognito.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  currentAccountEmail: string;
  currentAccountId: string;
  accountId$: ReplaySubject<string> = new ReplaySubject<string>(1);

  constructor(private injector: Injector) {}

  fetchAccountId() {
    // Try not to hold any dependency in the very base service.
    const getAccountIdQuery =
      this.injector.get<GetAccountIdGQL>(GetAccountIdGQL);
    const email = getLastAuthUser();
    return getAccountIdQuery.fetch({ email: email }).pipe(
      take(1),
      map((res) => {
        // Update it
        const accountId = res.data.getAccountId;
        this.updateCurrentAccountId(accountId, email);
        //
        return accountId;
      })
    );
  }

  updateCurrentAccountId(accountId: string, accountEmail?: string) {
    this.currentAccountId = accountId;
    this.currentAccountEmail = accountEmail || null;
    this.accountId$.next(accountId);
  }

  getCurrentAccountId() {
    return this.accountId$.pipe(
      filter((accountId) => !!accountId),
      take(1)
    );
  }
}
